import React from 'react';
import { Button } from 'primereact/button';

function PrimeReactButton(props) {
  const { onButtonClick = (e) => {}, children = null, isDisabled = false, ...rest } = props || {};
  return (
    <Button
      onClick={(e) => {
        onButtonClick(e);
      }}
      disabled={isDisabled}
      {...rest}
    >
      {children ? children : null}
    </Button>
  );
}

export default PrimeReactButton;
